<script lang="ts">
  import { Button } from '$shared/components';
  import FileList from './FileList.svelte';
  import type { XFile } from '$shared/models/XFile';

  interface Props {
    loading?: boolean;
    files: XFile[];
    children?: import('svelte').Snippet;
    onevent?: (payload: any) => void;
  }

  let { loading = false, files, children, onevent }: Props = $props();

  const onClickAttach = (): void => {
    onevent?.({ type: 'attach' });
  };
</script>

<div class="complete-state">
  <div class="file-attach">
    <Button name="cvo-popup-attach" {loading} icon="icon-paperclip" onclick={onClickAttach}>
      Attach
    </Button>
  </div>
  <FileList {files} {onevent} />
  {@render children?.()}
</div>

<style>
  .file-attach {
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 12px 8px;
    margin-top: -3px;
    border-radius: 0 0 3px 3px;
    z-index: 1;
  }
</style>
